import { render, staticRenderFns } from "./RewardsCardHome.vue?vue&type=template&id=3e40c059&scoped=true&"
import script from "./RewardsCardHome.vue?vue&type=script&lang=js&"
export * from "./RewardsCardHome.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCardHome.vue?vue&type=style&index=0&id=3e40c059&lang=scss&scoped=true&"
import style1 from "./RewardsCardHome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e40c059",
  null
  
)

export default component.exports